// The switch under the runner's line: the user sets up a computer other than the one this page is on.
import type { RunnerOs } from "./runnerChat";

export function RunnerOsSwitch({ os, onChange }: { os: RunnerOs; onChange: (os: RunnerOs) => void }) {
  return (
    <div className="segmented seg-sm runner-os" role="group" aria-label="The computer you set up">
      {(
        [
          ["windows", "Windows"],
          ["unix", "Mac or Linux"],
        ] as const
      ).map(([id, label]) => (
        <button key={id} type="button" className={os === id ? "is-on" : undefined} aria-pressed={os === id} onClick={() => onChange(id)}>
          {label}
        </button>
      ))}
    </div>
  );
}
